import React from 'react';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { FormHelperText } from '@mui/material';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: { maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP, },
    },
};

export function MultipleSelect({
    data,
    values,
    handleChange,
    label = 'Seleecione...',
    name = '',
    required = false,
    error = false,
    errorText = 'Campo requerido'
}) {
    return (
        <>
            {
                data.length > 0 && values ?
                    <FormControl
                        fullWidth
                        size="small"
                        error={error}
                    >
                        <InputLabel id={label + 'id'}>{label}</InputLabel>
                        <Select
                            labelId={label + 'id'}
                            name={name || label}
                            style={{ width: '100%', minHeight: 35 }}
                            id="multiple-checkbox"
                            className='multiple-select-custom'
                            multiple
                            value={values}
                            onChange={handleChange}
                            renderValue={(selected) => selected.map(obj => data.find(item => item.value === obj).key).join(', ')}
                            MenuProps={MenuProps}
                            required={required}
                        >
                            {
                                data.length > 0 &&
                                data.map((value) => (
                                    <MenuItem key={value.value} value={value.value} checked={values.find(item => item === value.value)} >
                                        <ListItemText primary={value.key} checked={values.find(item => item === value.value)} />
                                    </MenuItem>
                                ))
                            }
                        </Select>
                        {error && errorText &&
                            <FormHelperText>{errorText}</FormHelperText>
                        }
                    </FormControl>
                    :
                    <Select
                        style={{ width: '100%', height: 35 }}
                        label={label}
                        multiple
                        value={[]}
                        onChange={[]}
                    >
                    </Select>
            }
        </>
    );
}